import { NgFor } from '@angular/common';
import { AfterViewInit, Component, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-projects',
  imports: [NgFor],
  templateUrl: './projects.html',
  styleUrl: './projects.css',
})
export class Projects implements AfterViewInit, OnDestroy {
  private projectObserver?: IntersectionObserver;
  readonly projects = [
    {
      title: 'NxtGen Media',
      description:
        'Shaping brand narratives and digital growth strategies for the modern age',
      detail:
        '',
      domain: 'nxtgenmedia.info',
    },
    {
      title: 'Phonemarket',
      description:
        'Creating transparent, trust-based ecosystems for high-velocity commerce',
      detail:
        '',
      domain: 'phonemarket.pk',
    },
    {
      title: 'Tricore Logics',
      description:
        'A technology driven company delivering smart digital solutions.From development to automation, it powers businesses with innovation',
      detail:
        '',
      domain: 'trilogics.dev',
    },
    {
      title: 'Parhai',
      description:
        'Reimagining the future of education through accessible and impactful platforms.',
      detail:
        '',
      domain: 'parhai.pk',
    },
    {
      title: '141 Esports',
      description:
        'A competitive gaming and esports platform built for the next generation of gamers, hosting events, building communities, and shaping the esports ecosystem.',
      detail:
        '',
      domain: '141esports.com',
    },
  ];

  ngAfterViewInit(): void {
    if (window.innerWidth <= 1024) {
      this.observeProjects();
    }
  }

  ngOnDestroy(): void {
    this.projectObserver?.disconnect();
  }

  private observeProjects(): void {
    const elements = Array.from(document.querySelectorAll<HTMLElement>('.project-row'));
    if (!elements.length) {
      return;
    }

    this.projectObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Remove active from all
            document.querySelectorAll('.project-row.active').forEach(el => el.classList.remove('active'));
            entry.target.classList.add('active');
          } else {
            entry.target.classList.remove('active');
          }
        });
      },
      {
        threshold: 0,
        rootMargin: '-49% 0px -49% 0px',
      }
    );

    elements.forEach((element) => this.projectObserver?.observe(element));
  }
}
